export interface IClearWrapper {
    toastId?: string;
    toastContainerId?: number;
}
